import React from 'react';
import { Cushion, Typography } from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';

const NoCommentsPlaceholder = () => (
  <Cushion all="medium">
    <Typography align="center" component="div" preset="subtitle--large">
      <Trans i18nKey="common.no_comments">No comments</Trans>
    </Typography>
  </Cushion>
);

export default NoCommentsPlaceholder;
